module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 2\"><path d=\"M0 0h12v2H0z\"></path></svg>"